import { render, staticRenderFns } from "./package-user-calendar-add-item.vue?vue&type=template&id=608f4132&"
import script from "./package-user-calendar-add-item.vue?vue&type=script&lang=js&"
export * from "./package-user-calendar-add-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports